
import React from 'react';

const DataDeletion = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">VI. Data delection and storage period</h3>
      <p className="text-gray-600">
        For each processing activity we undertake, we will indicate below how long your data will be stored by us and when it will be deleted or blocked. If no specific storage period is indicated below, your personal data will be deleted or blocked as soon as the purpose or legal basis for the storage ceases to apply. Your data will generally only be stored on our servers in Frankfurt Germany DCs of AWS, subject to any transfer that may occur under the provisions in Part A. Sections VIII. and IX.
      </p>
      <p className="text-gray-600">
        However, storage may continue beyond the specified period in the event of a (potential) legal dispute with you or other legal proceedings, or if storage is required by legal provisions to which we, as the controller, are subject to. When the storage period required by law expires, your personal data will be blocked or deleted unless further storage by us is necessary and there is a legal basis for such storage. The following factors may play a role in determining whether further storage is necessary:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-gray-600">
        <li>legal obligations to store data for a longer period;</li>
        <li>statutory limitation periods;</li>
        <li>(potential) legal disputes; or</li>
        <li>guidelines and orders issued by competent data protection authorities.</li>
      </ul>
      <p className="text-gray-600">
        In cases where we continue to process your personal data for the aforementioned reasons, we will ensure that such data is treated in accordance with this privacy policy. Otherwise, we will delete your data as soon as it is no longer needed.
      </p>
      <p className="text-gray-600">
        If you would like to know how long we store your personal data for a specific purpose, you can contact us under info@ai-brainvisuals.com .\
      </p>
      <p className="text-gray-600">
        Further information on the storage period for cookies can be found in Part B. Section VI.
      </p>
    </div>
  );
};

export default DataDeletion;
